module.exports = __webpack_public_path__ + "static/media/logout.8d5726f4.svg";